import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { serverUrl } from '../../constants'

// Define a service using a base URL and expected endpoints
export const signUpApi = createApi({
  reducerPath: 'signUp',
  baseQuery: fetchBaseQuery({
    baseUrl: serverUrl,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.value
      // console.log('token state', token)
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      headers.set('Content-Type', `application/json`)
      return headers
    }
  }),
  tagTypes: ['SignUp', 'User'],
  endpoints: (builder) => ({
    fetchUser: builder.query({
      query: () => ({
        url: `getUser`,
      }),
      providesTags: ['User'],
    }),
    updateBusiness: builder.mutation({
      query: ({ mId, id, ...rest }) => ({
        url: `business/${id}?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['User'],
    }),
    updateResources: builder.mutation({
      query: ({ mId, ...rest }) => ({
        url: `resources?mId=${mId}`,
        method: 'POST',
        body: rest
      }),
      invalidatesTags: ['User'],
    }),
    signUpUser: builder.mutation({
      query: ({ mId, ...rest }) => ({
        url: `signUp`,
        method: 'POST',
        body: rest
      }),
      providesTags: ['SignUp'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFetchUserQuery, useSignUpUserMutation, useUpdateBusinessMutation, useUpdateResourcesMutation } = signUpApi